import {
    Box,
} from '@chakra-ui/react';

import { ACTIVITIES } from '../Components/info_all_activities';
import EventIntro_0 from './eventIntro_0'; 
import EventIntro_1 from './eventIntro_1'; 
import EventIntro_2 from './eventIntro_2';
import EventIntro_3 from './eventIntro_3';
import EventIntro_4 from './eventIntro_4';
import EventIntro_5 from './eventIntro_5';
import EventIntro_6 from './eventIntro_6';
import EventIntro_7 from './eventIntro_7';
import EventIntro_8 from './eventIntro_8';
import EventIntro_9 from './eventIntro_9';

const eventIntroComponents = {
    '0': EventIntro_0,
    '1': EventIntro_1,
    '2': EventIntro_2,
    '3': EventIntro_3,
    '4': EventIntro_4,
    '5': EventIntro_5,
    '6': EventIntro_6,
    '7': EventIntro_7,
    '8': EventIntro_8,
    '9': EventIntro_9,
  };

const Event = ({id}) => {
    const EventIntroComponent = eventIntroComponents[id];

    return (
        <Box
            bg="#edf3f8"
            p={10}
            w="full"
        >
            <EventIntroComponent  activity={ACTIVITIES[id]}></EventIntroComponent>
        </Box>
    )
}
export default Event;
